import { render, staticRenderFns } from "./TermsAndConditions.vue?vue&type=template&id=e0623f9a&scoped=true"
import script from "./TermsAndConditions.vue?vue&type=script&lang=ts"
export * from "./TermsAndConditions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0623f9a",
  null
  
)

export default component.exports